define('viewmodels/ActionTracker/ActionPlanDetails',['knockout', 'plugins/router', 'durandal/app', 'services/appsecurity', 'services/navigation', 'durandal/system', 'services/logger', 'services/utils', 'viewmodels/ActionTracker/ActionPlanManagement', 'viewmodels/ActionTracker/ActionItemDashboard'],
    function (ko, router, app, appsecurity, navigation, system, logger, utils, vmActionPM, ActionItemDashboardVM) {
    var ActionPlanDetailsVM = {
        title: ko.observable("Action Plan Details"),
        attached: attached,
        activate: activate,
        deactivate: deactivate,
        dettached: dettached,
        appsecurity: appsecurity,
        logger: logger,
        ActionItemNumber: ko.observable(),
        utils: utils,
        CompletedFlag: ko.observable(),
        vmActionPM: vmActionPM,
        ActionItemDashboardVM: ActionItemDashboardVM,
        ResponseMoveArrayItem: ko.observableArray([]),
        BackToAPM: BackToAPM,
        ActionPlanDetailsModel: ko.observableArray([]),
        ActionPlanId : ko.observable(0),
        
        CloseEditPlanDetailsPopUp: CloseEditPlanDetailsPopUp,
        ActionPlanPriorityList: ko.observableArray([]),
        EditActionPlanDetails: EditActionPlanDetails,
        SaveActionPlanDetails: SaveActionPlanDetails,
        EditActionPlanDates: EditActionPlanDates,
        SaveActionPlanDates: SaveActionPlanDates,
        AssignPlanOwners: AssignPlanOwners,
        AssignPlanReviewers: AssignPlanReviewers,

        SaveActionPlanOwner: SaveActionPlanOwner,
        SaveActionPlanReviewer: SaveActionPlanReviewer,
        CloseAssignPlanPopUp: CloseAssignPlanPopUp,
        RolesDrpDwnList: ko.observableArray([]),
        ActionPlanOwnerList: ko.observableArray([]),
        ActionPlanReviewerList: ko.observableArray([]),
        SaveCommentsRichText: SaveCommentsRichText,
        ActionPlanCommentsList: ko.observableArray(),
        ActionPlanEventList: ko.observableArray(),
        HistoryLogAccClick: HistoryLogAccClick,
        FilteredQuestionsList: ko.observableArray([]),
     
        ActionPlanDocList: ko.observableArray([]),
        UploadAttachmentForPlan: UploadAttachmentForPlan,
        SelectAllPlanOwners: SelectAllPlanOwners,
        SelectAllPlanReviewers: SelectAllPlanReviewers,
        ActionPlanPriorityChange: ActionPlanPriorityChange,
        UploadFileSize: ko.observable(20145728), //this size has to be mentioned in Bytes
        ProgressMessage: ko.observable(),
        DeleteAttachment: DeleteAttachment,
        DownloadAttachment: DownloadAttachment,
        AttachmentAccordian: AttachmentAccordian,
        DeleteComment: DeleteComment,
        EditComment: EditComment,
        SaveEditComment: SaveEditComment,
        CommentId: ko.observable(0),
        ViewActionItemDetails: ViewActionItemDetails,
        CreateActionItemFromPlan: CreateActionItemFromPlan,
        ActionItemLabel: ko.observable(),
        ClearEditComment: ClearEditComment,
        AssignPlanOwnerSingle: AssignPlanOwnerSingle,
        AssignPlanReviewerSingle: AssignPlanReviewerSingle,
        IsPageFromDashboard: ko.observable(false),
        BackToDashboard: BackToDashboard,
        ActionPlanPossibleList: ko.observableArray([]),
        ClearPosComment: ClearPosComment,
        SaveCommentPosText: SaveCommentPosText,
        EventId: ko.observable(),
        ActionPlanPosCommentsList: ko.observableArray([]),
        UnlinkActionItemFromPlan: UnlinkActionItemFromPlan,
        ActionPlanLabel: ko.observable(),
        AttachmentComment: ko.observable(""),
    };
    return ActionPlanDetailsVM;

    function attached() {
        try {
            if (ActionPlanDetailsVM.appsecurity.ActionPageType() == "PlanManagement" && ActionPlanDetailsVM.vmActionPM != undefined && ActionPlanDetailsVM.vmActionPM.ResponseMoveArray() != undefined && ActionPlanDetailsVM.vmActionPM.ResponseMoveArray().length != 0 && ActionPlanDetailsVM.vmActionPM.ResponseMoveArray().IsFromDashboard() == false) {
                ActionPlanDetailsVM.ActionPlanId(ActionPlanDetailsVM.vmActionPM.ResponseMoveArray().ActionPlanId());
                $("#ScreennameSurvey").html("Action Plan Details (<i>" + ActionPlanDetailsVM.vmActionPM.ResponseMoveArray().ActionPlanLabel() + "</i>)");
                ActionPlanDetailsVM.ActionPlanLabel(ActionPlanDetailsVM.vmActionPM.ResponseMoveArray().ActionPlanLabel());
                ActionPlanDetailsVM.IsPageFromDashboard(false);
            } 
            else if (ActionPlanDetailsVM.appsecurity.ActionPageType() != "PlanManagement" && ActionPlanDetailsVM.ActionItemDashboardVM != undefined && 
                        ActionPlanDetailsVM.ActionItemDashboardVM.ResponseMoveArray() != undefined && ActionPlanDetailsVM.ActionItemDashboardVM.ResponseMoveArray().length != 0 
                       ) {
                    ActionPlanDetailsVM.IsPageFromDashboard(true);
                    ActionPlanDetailsVM.ActionPlanId(ActionPlanDetailsVM.ActionItemDashboardVM.ResponseMoveArray().ActionItemId());
                    ActionPlanDetailsVM.ActionPlanLabel(ActionPlanDetailsVM.ActionItemDashboardVM.ResponseMoveArray().ActionItemNumber());
                    ActionPlanDetailsVM.CompletedFlag(ActionPlanDetailsVM.ActionItemDashboardVM.ResponseMoveArray().CompletedFlag());

                    if (ActionPlanDetailsVM.appsecurity.ActionPlanId() != undefined && ActionPlanDetailsVM.appsecurity.ActionPlanId() != "")
                    {
                        ActionPlanDetailsVM.ActionPlanId(ActionPlanDetailsVM.appsecurity.ActionPlanId());
                        ActionPlanDetailsVM.ActionPlanLabel(ActionPlanDetailsVM.appsecurity.ActionPlanLabel());
                }
                    $("#ScreennameSurvey").html("Action Plan Details (<i>" + ActionPlanDetailsVM.ActionPlanLabel() + "</i>)");
                    //populate possible actions dropdown
                    GetActionItemAction(ActionPlanDetailsVM.ActionItemDashboardVM.ResponseMoveArray().RoleId());
                    //Get possible action comments
                    GetActionPlanPossibleComments();
            }
                else {
                    router.navigate("#ActionTracker/ActionPlanManagement", true);
                    logger.logError('Some error occured, Please contact the Administrator', 'Error', system.getModuleId(ActionPlanDetailsVM), true);
                }
            

            GetActionPlanDetails();

        }
        catch (e) {
            var msg = 'Exception' + e + ' | Source | activate() in ActionPlanDetails.js';
            logger.logMessage(msg);
        }
    };

    function activate() {
        try {
            $('.collapse.in').prev().css("background-color", "#0076A8;");
        }
        catch (e) {
            var msg = 'Exception' + e + ' | Source | activate() in ActionPlanDetails.js';
            logger.logMessage(msg);
        }
    };
    function deactivate() {
        try {

         
        }
        catch (e) {
            var msg = 'Exception' + e + ' | Source | activate() in ActionPlanDetails.js';
            logger.logMessage(msg);
        }
    };
    function dettached() {
        try {
           
        }
        catch (e) {
            var msg = 'Exception' + e + ' | Source | activate() in ActionPlanDetails.js';
            logger.logMessage(msg);
        }
    };


    function BackToAPM() {
        try {
            router.navigate("#ActionTracker/ActionPlanManagement", true);
        }
        catch (e) {
            var msg = 'Exception' + e + ' | Source | activate() in ActionPlanDetails.js';
            logger.logMessage(msg);
        }
    };
    function BackToDashboard() {
        try {
            router.navigate("#ActionTracker/ActionItemDashboard", true);
        }
        catch (e) {
            var msg = 'Exception' + e + ' | Source | BackToDashboard() in ActionPlanDetails.js';
            logger.logMessage(msg);
        }
    };

    
    function ClearEditComment() {
        try {
            $("#RichTextComments").show();
            $("#EditRichTextComments").hide();
            $('.jqte_editor').html("");
            $('#TextComment').val('');
        }
        catch (e) {
            var msg = 'Exception' + e + ' | Source | ClearEditComment() in ActionPlanDetails.js';
            logger.logMessage(msg);
        }
    };

    function UnlinkActionItemFromPlan(data) {
        try {
            $("#loadingActionItemList").show();
            var csrfToken = $("input[name='__RequestVerificationToken']").val();
            var headers = appsecurity.getSecurityHeaders();
            headers.__RequestVerificationToken = csrfToken;
            return $.ajax({
                url: "/api/ActionPlan/UnlinkActionItemFromPlan",
                type: "POST",
                headers: headers,
                data: {
                    ActionPlanId: ActionPlanDetailsVM.ActionPlanId(), ActionItemId: data.AIM_UID()
                }
            })
                .success(function (jsonResult, error) {
                    if (jsonResult != undefined && jsonResult != -1) {
                        $("#loadingActionItemList").hide();
                        GetActionItemListForPlan();
                        logger.logSuccess('Unlink Action Item is Successfull ', 'Success', system.getModuleId(ActionPlanDetailsVM), true);
                    } else {
                        
                        $("#loadingActionItemList").hide();
                        logger.logError('Some error occured', 'Error', system.getModuleId(ActionPlanDetailsVM), true);
                    }
                })
                .fail(function (jsonResult, error) {
                    $("#loadingImgComment").hide();
                    logger.logError('An error has occurred. Please contact your Administrator.', 'Error', system.getModuleId(ActionPlanDetailsVM), true);
                });
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: ajaxSuccess in UnlinkActionItemFromPlan() method in ActionPlanDetails.js';
            logger.logMessage(msg);
        }
    }

    function GetActionPlanDetails() {
                try {
                    $.ajax({
                        url: "/api/ActionPlan/GetActionPlanDetails",
                        type: "GET",
                        data: { "ActionPlanId": ActionPlanDetailsVM.ActionPlanId() },
                        headers: appsecurity.getSecurityHeaders()
                    })
                    .success(ajaxSuccess)
                    .fail(ajaxFail);
                }
                catch (e) {
                    var msg = 'Exception' + e + ' | source: GetActionPlanDetails() in ActionPlanDetails.js';
                    logger.logMessage(msg)
                }
                function ajaxSuccess(jsonResult, status) {
                    try {
                        ActionPlanDetailsVM.ActionPlanDetailsModel([]);
                        if (jsonResult != null) {
                            var mappedModel = $.map(jsonResult, function (result) {
                                return new ActionPlanDetailModel(result);
                            });
                            ActionPlanDetailsVM.ActionPlanDetailsModel(mappedModel[0]);
                            //$("#TextComment").jqte();
                            $("#EditTextComment").jqte();
                            $("#RichTextComments").show();
                            $("#EditRichTextComments").hide();
                            GetActionPlanDocs();
                            GetActionItemListForPlan();
                            GetActionPlanComments();
                        }
                        else {
                            ActionPlanDetailsVM.ActionPlanDetailsModel([]);
                        }
                    }
                    catch (e) {
                        var msg = 'exception' + e + ' | source: ajaxSucess() in GetActionPlanDetails() in ActionPlanDetails.js';
                        logger.logMessage(msg);
                    }
                }

                function ajaxFail(error, status) {
                    try {
                        if (error.status == 401) {
                            app.showMessage("You have been logged out. Please login again to complete the operation.", "Error in Get Operation", ["OK"], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                            .then(function (option) {
                                if (option == "OK")
                                    navigation.unauthorized();
                            })
                        }
                        else {
                            var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in GetActionPlanDetails() method in ActionPlanDetails.js';
                            logger.logMessage(msg);
                        }
                    }
                    catch (e) {
                        var msg = 'Exception: ' + e + ' | Source: ajaxFail in GetActionPlanDetails() method in ActionPlanDetails.js';
                        logger.logMessage(msg);
                    }
                }
        };
        

    
    function ActionPlanDetailModel(item) {
        var self = this;
        self.ActionPlanId = ko.observable($('<div/>').html(item.ActionPlanId).text());
        self.ActionPlanTitle = ko.observable($('<div/>').html(item.ActionPlanTitle).text());
        self.ActionPlanLabel = ko.observable($('<div/>').html(item.ActionPlanLabel).text());
        self.ActionPlanDescription = ko.observable($('<div/>').html(item.ActionPlanDescription).text());
        self.ActionPlanPriority = ko.observable($('<div/>').html(item.ActionPlanPriority).text());
        self.ActionPlanPriorityId = ko.observable($('<div/>').html(item.ActionPlanPriorityId).text());
        self.PlanOwner = ko.observable($('<div/>').html(item.PlanOwner).text());
        self.PlanReviewer = ko.observable($('<div/>').html(item.PlanReviewer).text());   
        self.ActionPlanStartDate = ko.observable($('<div/>').html(item.ActionPlanStartDate).text());
        self.ActionPlanEndDate = ko.observable($('<div/>').html(item.ActionPlanEndDate).text());
        self.Status = ko.observable($('<div/>').html(item.Status).text());
        self.EstimatedStartDate = ko.observable($('<div/>').html(item.EstimatedStartDate).text());
        self.EstimatedEndDate = ko.observable($('<div/>').html(item.EstimatedEndDate).text());
        self.CreatedByUser = ko.observable($('<div/>').html(item.CreatedByUser).text());
        self.CreatedDate = ko.observable($('<div/>').html(item.CreatedDate).text());
        self.DueDate = ko.observable($('<div/>').html(item.DueDate).text());
        self.AssignedPlanOwner = ko.observable($('<div/>').html(item.AssignedPlanOwner).text());
        self.AssignedPlanManager = ko.observable($('<div/>').html(item.AssignedPlanManager).text());
    }

    function CloseEditPlanDetailsPopUp() {
        try {
            $("#EditPlanDetailsPopUp").modal('hide');
            $("#EditPlanDatesPopUp").modal('hide');
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: ajaxSuccess in CloseCreateActionPlanPopUp() method in ActionPlanDetails.js';
            logger.logMessage(msg);
        }
    }

    
    
    function EditActionPlanDetails(data) {
        try {

            if (ActionPlanDetailsVM.ActionPlanDetailsModel() == undefined || ActionPlanDetailsVM.ActionPlanDetailsModel() == null) {
                GetActionPlanDetails();
            }

            var MockedPriorityList = [
                {
                    "PriorityId": 1,
                    "PriorityLevel": "High"
                },
                {
                    "PriorityId": 2,
                    "PriorityLevel": "Medium"
                },
                {
                    "PriorityId": 3,
                    "PriorityLevel": "Low"
                }
            ];

            ActionPlanDetailsVM.ActionPlanPriorityList(MockedPriorityList);
            $("#txtActionPlanTitle").val(data.ActionPlanTitle());
            $("#txtActionPlanDescription").val(data.ActionPlanDescription());
            $("#ddlActionPlanPriority").val(data.ActionPlanPriorityId());
            
            $("#EditPlanDetailsPopUp").modal('show');
            $("#valDetailsError").hide();
            
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: ajaxSuccess in EditActionPlanDetails() method in ActionPlanDetails.js';
            logger.logMessage(msg);
        }
    }

    function SaveActionPlanDetails() {
        try {
            $("#valDetailsError").hide();
            if ($('#txtActionPlanTitle').val() == undefined || $('#txtActionPlanTitle').val() == "") {
                $('#valDetailsError').show();
                $('#valDetailsError').html('Action plan title is mandatory');
            }
            else {
                $("#loadingImgEditPlanBasicInfo").show();

                var csrfToken = $("input[name='__RequestVerificationToken']").val();
                var headers = appsecurity.getSecurityHeaders();
                headers.__RequestVerificationToken = csrfToken;
                return $.ajax({
                    url: "/api/ActionPlan/UpdateActionPlan",
                    type: "POST",
                    headers: headers,
                    data: { ActionPlanId: ActionPlanDetailsVM.ActionPlanId(), ActionPlanTitle: $('#txtActionPlanTitle').val(), ActionPlanDescription: $('#txtActionPlanDescription').val(), ActionPlanPriority: $('#ddlActionPlanPriority').val() }
                })
                    .success(function (jsonResult, error) {
                        if (jsonResult != undefined && jsonResult == 1) {
                                GetActionPlanDetails();
                            logger.logSuccess('Action Plan Details Updated Successfully ', 'Success', system.getModuleId(ActionPlanDetailsVM), true);
                        } else {
                            logger.logError('Some error occured while updating details.', 'Error', system.getModuleId(ActionPlanDetailsVM), true);
                        }
                        $("#loadingImgEditPlanBasicInfo").hide();
                        $("#EditPlanDetailsPopUp").modal('hide');

                    })
                    .fail(function (jsonResult, error) {
                        $("#loadingImgEditPlanBasicInfo").hide();
                        logger.logError('An error has occurred while fetching the Filter values. Please contact your Administrator.', 'Error', system.getModuleId(vm), true);
                    });

            }
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: ajaxSuccess in SaveActionPlanDetails() method in ActionPlanDetails.js';
            logger.logMessage(msg);
        }
    }
 
    function EditActionPlanDates(data) {
        try {
            if (ActionPlanDetailsVM.ActionPlanDetailsModel() == undefined || ActionPlanDetailsVM.ActionPlanDetailsModel() == null) {
                GetActionPlanDetails();
            }
            $("#APStartDate").datepicker();
            $("#APEndDate").datepicker();
            
            $("#APStartDate").val(data.EstimatedStartDate());
            $("#APEndDate").val(data.EstimatedEndDate());
            

            $("#EditPlanDatesPopUp").modal('show');
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: ajaxSuccess in EditActionPlanDates() method in ActionPlanDetails.js';
            logger.logMessage(msg);
        }
    }

    function SaveActionPlanDates() {
        try {
            $("#loadingImgEditPlanDateInfo").show();
                var csrfToken = $("input[name='__RequestVerificationToken']").val();
                var headers = appsecurity.getSecurityHeaders();
                headers.__RequestVerificationToken = csrfToken;
                return $.ajax({
                    url: "/api/ActionPlan/UpdateActionPlan",
                    type: "POST",
                    headers: headers,
                    data: { ActionPlanId: ActionPlanDetailsVM.ActionPlanId(), EstimatedStartDate: $('#APStartDate').val(), EstimatedEndDate: $('#APEndDate').val() }
                })
                    .success(function (jsonResult, error) {
                        if (jsonResult != undefined && jsonResult == 1) {
                            GetActionPlanDetails();
                            $("#collapse1").removeClass("in");
                            $("#collapse2").addClass("in");
                            logger.logSuccess('Action Plan Details Updated Successfully ', 'Success', system.getModuleId(ActionPlanDetailsVM), true);
                            $("#loadingImgEditPlanDateInfo").hide();
                            $("#EditPlanDatesPopUp").modal('hide');
                        } else {
                            $("#loadingImgEditPlanDateInfo").hide();
                            logger.logError('Some error occured while updating details.', 'Error', system.getModuleId(ActionPlanDetailsVM), true);
                        }
                        $("#EditPlanDatesPopUp").modal('hide');
                    })
                    .fail(function (jsonResult, error) {
                        $("#loadingImgEditPlanDateInfo").hide();
                        logger.logError('An error has occurred while fetching the Filter values. Please contact your Administrator.', 'Error', system.getModuleId(vm), true);
                    });
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: ajaxSuccess in SaveActionPlanDates() method in ActionPlanDetails.js';
            logger.logMessage(msg);
        }
    }


    function GetActionItemAction(RoleId) {
        try {
            $.ajax({
                url: "/api/ActionPlan/GetActionsList?ActionItemId=" + ActionPlanDetailsVM.ActionPlanId() + "&RoleId=" + RoleId + "&TableKey=" + "ACTION PLAN",
                type: "GET",
                headers: appsecurity.getSecurityHeaders()
            })
            .success(ajaxSuccess)
            .fail(ajaxFail);
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: ajax call in GetActionItemAction() method in ActionItemDetails.js';
            logger.logMessage(msg);
        }

        function ajaxSuccess(jsonResult, error) {
            try {
                ActionPlanDetailsVM.ActionPlanPossibleList([]);
                if (jsonResult != null) {
                    var mappedActionsList = $.map(jsonResult, function (result) {
                        return new ActionItemActionsModel(result);
                    });
                    ActionPlanDetailsVM.ActionPlanPossibleList(mappedActionsList);
                }
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajaxSuccess in GetActionItemAction() method in ActionPlanDetails.js';
                logger.logMessage(msg);
            }
        }

        function ajaxFail(error, status) {
            try {
                if (error.status == 401) {
                    app.showMessage("You have been logged out. Please login again to complete the operation.", "Error in Edit Operation", ["OK"], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                    .then(function (option) {
                        if (option == "OK")
                            navigation.unauthorized();
                    })
                }
                else {
                    var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in GetActionItemAction() method in ActionPlanDetails.js';
                    logger.logMessage(msg);
                }
            } catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajaxFail in GetActionItemAction() method in ActionPlanDetails.js';
                logger.logMessage(msg);
            }
        };
    }

    function ActionItemActionsModel(item) {
        try {
            var self = this;
            self.EventId = ko.observable(item.EventId);
            self.EventName = ko.observable($('<div/>').html(item.EventName).text());
            self.NextState = ko.observable($('<div/>').html(item.NextState).text());
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: ActionItemActionsModel() method in ActionItemDetails.js';
            logger.logMessage(msg);
        }
    }

    
    function SaveCommentPosText() {
        try {
            $('#valPosError').hide();
            if ($("#PossibleActionStatus").val() == "" || $("#PossibleActionsComment").val() == "") {
                $('#valPosError').show();
                $('#valPosError').html('Please select possible action and provide a comment to save.');
            }
            else {
                   
                ActionPlanDetailsVM.EventId($("#PossibleActionStatus").val());
                $("#loadingImgPossibleComment").show();
                UpdatePossibleActionStatus();
            }
        }
        catch (e) {
            var msg = 'Exception' + e + ' | source: SaveCommentPosText() in ActionPlanDetails.js';
            logger.logMessage(msg)
        }
    }

    function SaveCommentPlanText() {
     try {
                var csrfToken = $("input[name='__RequestVerificationToken']").val();
                var headers = appsecurity.getSecurityHeaders();
                headers.__RequestVerificationToken = csrfToken;
                return $.ajax({
                    url: "/api/ActionPlan/SavePossibleActionComment?ActionPlanId=" + ActionPlanDetailsVM.ActionPlanId() + "&CommentText=" + $("#PossibleActionsComment").val(),
                    headers: headers,
                    type: "POST",
                })
                    .success(function (jsonResult, error) {
                        if (jsonResult != null) {
                           $('#PossibleActionsComment').val("");
                    $("#loadingImgPossibleComment").hide();
                    setTimeout(router.navigate("#ActionTracker/ActionItemDashboard", true), 200);
                    logger.logSuccess('Action has been performed successfully.', 'Success', system.getModuleId(ActionPlanDetailsVM), true);
                        } else {
                            $("#loadingImgPossibleComment").hide();
                            logger.logError('Some error occured', 'Error', system.getModuleId(ActionPlanDetailsVM), true);
                        }
                    })
                    .fail(function (jsonResult, error) {
                        $("#loadingImgPossibleComment").hide();
                        logger.logError('An error has occurred while fetching the Filter values. Please contact your Administrator.', 'Error', system.getModuleId(ActionPlanDetailsVM), true);
                    });
                 }
              catch (e) {
                var msg = 'Exception' + e + ' | source: SaveCommentPlanText() in ActionPlanDetails.js';
                        logger.logMessage(msg)
                    }
    }

    function UpdatePossibleActionStatus() {
        try {
            var csrfToken = $("input[name='__RequestVerificationToken']").val();
            var headers = appsecurity.getSecurityHeaders();
            headers.__RequestVerificationToken = csrfToken;
            $.ajax({
                url: "/api/ActionPlan/SetPerformAction?EventId=" + ActionPlanDetailsVM.EventId() + "&ActionItemId=" + ActionPlanDetailsVM.ActionPlanId() + "&TableKey=" + "ACTR.ACTION_PLAN_MASTER",
                headers: headers,
                type: "POST",
            })
            .success(ajaxSuccess)
            .fail(ajaxFail);
        } catch (e) {
            var msg = 'Exception: ' + e + ' | Source: ajax call in UpdateStatus() method in ActionPlanDetails.js';
            logger.logMessage(msg);
        }
        function ajaxSuccess(jsonResult, status) {
            try {
                if (jsonResult == 1000) {
                   // $('#PossibleActionsComment').val("");
                    $("#loadingImgPossibleComment").hide();
                    logger.logError('This plan cannot be moved to Action Owner(s) queue until all the action items in this plan are complete.', 'Error', system.getModuleId(ActionPlanDetailsVM), true);
                }
                if (jsonResult == 1) {
                    SaveCommentPlanText(); 
                }
                else if (jsonResult < 1)
                    logger.logError('An error occurred while performing selected action.', 'Error', system.getModuleId(ActionPlanDetailsVM), true);
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajaxSuccess in UpdateStatus() method in ActionPlanDetails.js';
                logger.logMessage(msg);
            }
        };

        function ajaxFail(error, status) {
            try {
                if (error.status == 401) {
                    app.showMessage("You have been logged out. Please login again to complete the operation.", "Error in Edit Operation", ["OK"], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                    .then(function (option) {
                        if (option == "OK")
                            navigation.unauthorized();
                    })
                }
                else {
                    var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in UpdateStatus() method in ActionItemDetails.js';
                    logger.logMessage(msg);
                }
            } catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajaxFail in UpdateStatus() method in ActionItemDetails.js';
                logger.logMessage(msg);
            }
        };
    }

    function GetActionPlanPossibleComments() {
        try {
            ActionPlanDetailsVM.ActionPlanCommentsList([]);
            var csrfToken = $("input[name='__RequestVerificationToken']").val();
            var headers = appsecurity.getSecurityHeaders();
            headers.__RequestVerificationToken = csrfToken;
            return $.ajax({
                url: "/api/ActionPlan/GetActionPlanPossibleComments",
                type: "GET",
                headers: headers,
                data: { ActionPlanId: ActionPlanDetailsVM.ActionPlanId() }
            })
                .success(function (jsonResult, error) {

                    ActionPlanDetailsVM.ActionPlanPosCommentsList([]);
                    if (jsonResult != null) {
                        var mappedRole = $.map(jsonResult, function (result) {
                            return new CommentsModel(result);
                        });
                        ActionPlanDetailsVM.ActionPlanPosCommentsList(mappedRole);
                    }
                    else {
                        ActionPlanDetailsVM.ActionPlanPosCommentsList([]);
                    }
                })
                .fail(function (jsonResult, error) {
                    logger.logError('An error has occurred while fetching the Filter values. Please contact your Administrator.', 'Error', system.getModuleId(vm), true);
                });
        }
        catch (e) {
            var msg = 'Exception' + e + ' | Source: GetActionPlanComments() in ActionPlanDetails.js';
            logger.logMessage(msg);
        }
    }

    function ClearPosComment() {
        try {
            $("#PossibleActionsComment").val("");
            $("#PossibleActionStatus").val("");
            $('#valPosError').hide();
        }
        catch (e) {
            var msg = 'Exception' + e + ' | source: ClearPosComment() in ActionPlanDetails.js';
            logger.logMessage(msg)
        }
    }

    function GetAllUserRole() {
        try {
            $.ajax({
                url: "/api/ActionPlan/GetAllUserRole",
                type: "GET",
                headers: appsecurity.getSecurityHeaders()
            })
            .success(ajaxSuccess)
            .fail(ajaxFail);
        }
        catch (e) {
            var msg = 'Exception' + e + ' | source: GetAllUserRole() in ActionPlanDetails.js';
            logger.logMessage(msg)
        }
        function ajaxSuccess(jsonResult, status) {
            try {
                if (jsonResult != null) {
                    var mappedRole = $.map(jsonResult, function (result) {
                        return new RoleModel(result);
                    });

                    var mappedRoleForGridOwner = $.map(jsonResult.Owners, function (result) {
                        return new OwnerReviewerListModel(result);
                    });

                    var mappedRoleForGridRev = $.map(jsonResult.Reviewers, function (result) {
                        return new OwnerReviewerListModel(result);
                    });
                    ActionPlanDetailsVM.ActionPlanOwnerList([]);
                    var object = $('#tblActionPlanOwner').DataTable();
                    object.destroy();
                    $('#tblActionPlanOwner tbody tr').remove();
                    ActionPlanDetailsVM.ActionPlanOwnerList(mappedRoleForGridOwner);

                    $("#tblActionPlanOwner").DataTable(
                        {
                            "aoColumnDefs": [{
                                "aTargets": [0],
                                "order": [],
                                "bSortable": false
                            }]
                        }
                        );

                    ActionPlanDetailsVM.ActionPlanReviewerList([]);
                    var object2 = $('#tblActionPlanReviewer').DataTable();
                    object2.destroy();
                    $('#tblActionPlanReviewer tbody tr').remove();
                    ActionPlanDetailsVM.ActionPlanReviewerList(mappedRoleForGridRev);

                    $("#tblActionPlanReviewer").DataTable(
                        {
                            "aoColumnDefs": [{
                                "aTargets": [0],
                                "order": [],
                                "bSortable": false
                            }]
                        }
                        );
                }
                else {
                    ActionPlanDetailsVM.ActionPlanOwnerList([]);
                    ActionPlanDetailsVM.ActionPlanReviewerList([]);
                }
            }
            catch (e) {
                var msg = 'exception' + e + ' | source: ajaxSucess() in GetAllUserRole() in ActionPlanDetails.js';
                logger.logMessage(msg);
            }
        }

        function ajaxFail(error, status) {
            try {
                if (error.status == 401) {
                    app.showMessage("You have been logged out. Please login again to complete the operation.", "Error in Edit Operation", ["OK"], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                    .then(function (option) {
                        if (option == "OK")
                            navigation.unauthorized();
                    })
                }
                else {
                    var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in GetAllUserRole() method in ActionPlanDetails.js';
                    logger.logMessage(msg);
                }
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajaxFail in GetAllUserRole() method in ActionPlanDetails.js';
                logger.logMessage(msg);
            }
        }
    }

    function GetAllUserRoleForPlan() {
        try {
            $.ajax({
                url: "/api/ActionPlan/GetAllUserRoleForPlan",
                type: "GET",
                data: { "ActionPlanId": ActionPlanDetailsVM.ActionPlanId() },
                headers: appsecurity.getSecurityHeaders()
            })
            .success(ajaxSuccess)
            .fail(ajaxFail);
        }
        catch (e) {
            var msg = 'Exception' + e + ' | source: GetAllUserRoleForPlan() in ActionPlanManagement.js';
            logger.logMessage(msg)
        }
        function ajaxSuccess(jsonResult, status) {
            try {
                if (jsonResult != null) {
                    var mappedRole = $.map(jsonResult, function (result) {
                        return new RoleModel(result);
                    });

                    var mappedRoleForGridOwner = $.map(jsonResult.Owners, function (result) {
                        return new OwnerReviewerListForPlanModel(result);
                    });

                    var mappedRoleForGridRev = $.map(jsonResult.Reviewers, function (result) {
                        return new OwnerReviewerListForPlanModel(result);
                    });
                    ActionPlanDetailsVM.ActionPlanOwnerList([]);
                    var object = $('#tblActionPlanOwner').DataTable();
                    object.destroy();
                    $('#tblActionPlanOwner tbody tr').remove();
                    ActionPlanDetailsVM.ActionPlanOwnerList(mappedRoleForGridOwner);

                    $("#tblActionPlanOwner").DataTable(
                        {
                            "aoColumnDefs": [{
                                "aTargets": [0],
                                "order": [],
                                "bSortable": false

                            }]
                        }
                        );

                    ActionPlanDetailsVM.ActionPlanReviewerList([]);
                    var object2 = $('#tblActionPlanReviewer').DataTable();
                    object2.destroy();
                    $('#tblActionPlanReviewer tbody tr').remove();
                    ActionPlanDetailsVM.ActionPlanReviewerList(mappedRoleForGridRev);

                    $("#tblActionPlanReviewer").DataTable(
                        {
                            "aoColumnDefs": [{
                                "aTargets": [0],
                                "order": [],
                                "bSortable": false

                            }]
                        }
                        );
                }
                else {
                    ActionPlanDetailsVM.ActionPlanOwnerList([]);
                    ActionPlanDetailsVM.ActionPlanReviewerList([]);
                }
            }
            catch (e) {
                var msg = 'exception' + e + ' | source: ajaxSucess() in GetAllUserRoleForPlan() in ActionPlanManagement.js';
                logger.logMessage(msg);
            }
        }

        function ajaxFail(error, status) {
            try {
                if (error.status == 401) {
                    app.showMessage("You have been logged out. Please login again to complete the operation.", "Error in Edit Operation", ["OK"], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                    .then(function (option) {
                        if (option == "OK")
                            navigation.unauthorized();
                    })
                }
                else {
                    var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in GetAllUserRoleForPlan() method in ActionPlanManagement.js';
                    logger.logMessage(msg);
                }
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajaxFail in GetAllUserRoleForPlan() method in ActionPlanManagement.js';
                logger.logMessage(msg);
            }
        }

    }

    function RoleModel(item) {
        try {
            var self = this;
            self.RoleId = ko.observable(item.RoleId);
            self.RoleName = ko.observable($('<div/>').html(item.RoleName).text());
            self.RoleType = ko.observable($('<div/>').html(item.RoleType).text());
            self.UserName = ko.observable($('<div/>').html(item.UserName).text());
        }
        catch (e) {
            var msg = 'Exception' + e + ' | Source: RoleModel() in ActionPlanDetails.js';
            logger.logMessage(msg);
        }
    }

    function OwnerReviewerListModel(item) {
        try {
            var self = this;
            self.IS_SELECTED = ko.observable(false);
            self.PlanOwnerId = ko.observable(item.RoleId);
            self.PlanOwnerName = ko.observable($('<div/>').html(item.RoleName).text());
            self.UserType = ko.observable($('<div/>').html(item.RoleType).text());
            self.UserName = ko.observable($('<div/>').html(item.UserName).text());
            self.UserId = ko.observable(item.UserId);
        }
        catch (e) {
            var msg = 'Exception' + e + ' | Source: OwnerReviewerListModel() in ActionPlanDetails.js';
            logger.logMessage(msg);
        }
    }

    function OwnerReviewerListForPlanModel(item) {
        try {
            var self = this;
            self.IS_SELECTED = ko.observable(item.IS_SELECTED);
            self.PlanOwnerId = ko.observable(item.RoleId);
            self.PlanOwnerName = ko.observable($('<div/>').html(item.RoleName).text());
            self.UserType = ko.observable($('<div/>').html(item.RoleType).text());
            self.UserName = ko.observable($('<div/>').html(item.UserName).text());
            self.UserId = ko.observable(item.UserId);
        }
        catch (e) {
            var msg = 'Exception' + e + ' | Source: OwnerReviewerListModel() in ActionPlanManagement.js';
            logger.logMessage(msg);
        }
    }

    function CloseAssignPlanPopUp() {
        try {
            $("#AssignOwnerPopUp").modal('hide');
            $("#AssignReviewerPopUp").modal('hide');
            $("#EditCommentPopUp").modal('hide');
            $('.jqte_editor').html("");

        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: ajaxSuccess in CloseAssignPlanPopUp() method in ActionPlanDetails.js';
            logger.logMessage(msg);
        }
    }

    function AssignPlanOwners() {
        try {
            $("#AssignOwnerPopUp").modal('show');
            GetAllUserRole();
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: CreateActionPlan() method in ActionPlanDetails.js';
            logger.logMessage(msg);
        }
    }
    function AssignPlanOwnerSingle(data) {
            try {
                $("#AssignOwnerPopUp").modal('show');
               // ActionPlanDetailsVM.ActionPlanId(data.ActionPlanId());
                GetAllUserRoleForPlan();
                //$("#AssignOwnerPopUp").modal('show');
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: CreateActionPlan() method in ActionPlanManagement.js';
                logger.logMessage(msg);
            }
        }

    function SaveActionPlanOwner() {
        try {
            var piperText = "";
            for (var i = 0; i < ActionPlanDetailsVM.ActionPlanOwnerList().length; i++) {
                if (ActionPlanDetailsVM.ActionPlanOwnerList()[i].IS_SELECTED() == true) {
                    piperText += ActionPlanDetailsVM.ActionPlanOwnerList()[i].UserName() + ", ";
                }
            }
            piperText = piperText.replace(/,\s*$/, "");
            $('#PlanOwners').val(piperText);

            var isListEmpty = true;
            for (var i = 0; i < ActionPlanDetailsVM.ActionPlanOwnerList().length; i++) {
                if (ActionPlanDetailsVM.ActionPlanOwnerList()[i].IS_SELECTED() == true) {
                    isListEmpty = false;
                    break;
                }
            }
            $('#valErrorOwner').hide();
            if (isListEmpty == true) {
                $('#valErrorOwner').show();
                $('#valErrorOwner').html('Please select atleast one plan owner');
            }
            else {
                $('#loadingImgAssignOwner').show();
                var csrfToken = $("input[name='__RequestVerificationToken']").val();
                var headers = appsecurity.getSecurityHeaders();
                headers.__RequestVerificationToken = csrfToken;
                return $.ajax({
                    url: "/api/ActionPlan/SaveActionPlanUsers",
                    type: "POST",
                    headers: headers,
                    contentType: 'application/json',
                    dataType: 'json',
                    data: JSON.stringify($.map(ActionPlanDetailsVM.ActionPlanOwnerList(), function (result) {
                        if (result.IS_SELECTED() == true) {
                            return {
                                ActionPlanId: ActionPlanDetailsVM.ActionPlanId(), RoleId: result.PlanOwnerId(), RoleType: "AP_ONR", UserId: result.UserId()                        };
                        }
                    }))
                })
                    .success(function (jsonResult, error) {
                        if (jsonResult != undefined && jsonResult != -1) {
                            logger.logSuccess('Details Updated Successfully', 'Success', system.getModuleId(ActionPlanDetailsVM), true);
                            $('#loadingImgAssignOwner').hide();
                            $("#AssignOwnerPopUp").modal('hide');
                        } else {
                            $('#loadingImgAssignOwner').hide();
                            logger.logError('Some Error occured while adding details.', 'Error', system.getModuleId(ActionPlanDetailsVM), true);
                        }
                    })
                    .fail(function (jsonResult, error) {
                        $('#loadingImgAssignOwner').hide();
                        logger.logError('An error has occurred while fetching the Filter values. Please contact your Administrator.', 'Error', system.getModuleId(vm), true);
                    });
                $("#AssignOwnerPopUp").modal('hide');
            }
            
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: SaveActionPlanOwner() method in ActionPlanDetails.js';
            logger.logMessage(msg);
        }
    }


    function AssignPlanReviewers() {
        try {
            $("#AssignReviewerPopUp").modal('show');
            GetAllUserRole();
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: AssignPlanReviewers() method in ActionPlanDetails.js';
            logger.logMessage(msg);
        }
    }

    function AssignPlanReviewerSingle(data) {
        try {
            $("#AssignReviewerPopUp").modal('show');
           // ActionPlanDetailsVM.ActionPlanId(data.ActionPlanId());
            GetAllUserRoleForPlan();
           // $("#AssignReviewerPopUp").modal('show');
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: AssignPlanReviewers() method in ActionPlanManagement.js';
            logger.logMessage(msg);
        }
    }

    function SaveActionPlanReviewer() {
        try {
            var piperText = "";
            for (var i = 0; i < ActionPlanDetailsVM.ActionPlanReviewerList().length; i++) {
                if (ActionPlanDetailsVM.ActionPlanReviewerList()[i].IS_SELECTED() == true) {
                    piperText += ActionPlanDetailsVM.ActionPlanReviewerList()[i].UserName() + "\n";
                }
            }
            piperText = piperText.replace(/,\s*$/, "");
            $('#PlanReviewers').val(piperText);

            var isListEmpty = true;
            for (var i = 0; i < ActionPlanDetailsVM.ActionPlanReviewerList().length; i++) {
                if (ActionPlanDetailsVM.ActionPlanReviewerList()[i].IS_SELECTED() == true) {
                    isListEmpty = false;
                    break;
                }
            }
            $('#valErrorReviewer').hide();
            if (isListEmpty == true) {
                $('#valErrorReviewer').show();
                $('#valErrorReviewer').html('Please select atleast one plan manager');
            }
            else {
                $('#loadingImgAssignManager').show();
                var csrfToken = $("input[name='__RequestVerificationToken']").val();
                var headers = appsecurity.getSecurityHeaders();
                headers.__RequestVerificationToken = csrfToken;
                return $.ajax({
                    url: "/api/ActionPlan/SaveActionPlanUsers",
                    type: "POST",
                    headers: headers,
                    contentType: 'application/json',
                    dataType: 'json',
                    data: JSON.stringify($.map(ActionPlanDetailsVM.ActionPlanReviewerList(), function (result) {
                        if (result.IS_SELECTED() == true) {
                            return { ActionPlanId: ActionPlanDetailsVM.ActionPlanId(), RoleId: result.PlanOwnerId(), RoleType: "AP_MGR", UserId: result.UserId() };
                        }
                    }))
                })
                    .success(function (jsonResult, error) {
                        if (jsonResult != undefined && jsonResult != -1) {
                            logger.logSuccess('Details Updated Successfully ', 'Success', system.getModuleId(ActionPlanDetailsVM), true);
                            $('#loadingImgAssignManager').hide();
                            $("#AssignReviewerPopUp").modal('hide');
                        } else {
                            $('#loadingImgAssignManager').hide();
                            logger.logError('Some Error occured while adding details.', 'Error', system.getModuleId(ActionPlanDetailsVM), true);
                        }
                    })
                    .fail(function (jsonResult, error) {
                        $('#loadingImgAssignManager').hide();
                        logger.logError('An error has occurred while fetching the Filter values. Please contact your Administrator.', 'Error', system.getModuleId(vm), true);
                    });
                $("#AssignReviewerPopUp").modal('hide');
            }  
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: SaveActionPlanOwner() method in ActionPlanDetails.js';
            logger.logMessage(msg);
        }
    }

    function SaveCommentsRichText() {
        try {

                $("#valDocError").hide();
                if ($('#TextComment').val() == undefined || $('#TextComment').val().length <=0) {
                    $('#valDocError').show();
                    $('#valDocError').html('Please add comment to save');
                }
                else {
                    $("#loadingImgComment").show();
                    var csrfToken = $("input[name='__RequestVerificationToken']").val();
                    var headers = appsecurity.getSecurityHeaders();
                    headers.__RequestVerificationToken = csrfToken;
                    return $.ajax({
                        url: "/api/ActionPlan/SaveCommentsRichText",
                        type: "POST",
                        headers: headers,
                        data: { ActionPlanId: ActionPlanDetailsVM.ActionPlanId(), HtmlComment: $('#TextComment').val() }
                    })
                        .success(function (jsonResult, error) {
                            if (jsonResult != undefined && jsonResult != -1) {
                                $('#TextComment').val('');
                                $("#loadingImgComment").hide();
                                GetActionPlanComments();
                                logger.logSuccess('Comment saved successfully ', 'Success', system.getModuleId(ActionPlanDetailsVM), true);
                            } else {
                                $("#loadingImgComment").hide();
                                logger.logError('Some error occured', 'Error', system.getModuleId(ActionPlanDetailsVM), true);
                            }
                        })
                        .fail(function (jsonResult, error) {
                            $("#loadingImgComment").hide();
                            logger.logError('An error has occurred while fetching the Filter values. Please contact your Administrator.', 'Error', system.getModuleId(ActionPlanDetailsVM), true);
                        });

                }
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajaxSuccess in SaveCommentsRichText() method in ActionPlanDetails.js';
                logger.logMessage(msg);
            }
        }

    function CommentsModel(item) {
        try {
            var self = this;
            self.CommentId = ko.observable(item.CommentId);
            self.CommentText = ko.observable(item.CommentText);
            self.CommentBy = ko.observable($('<div/>').html(item.CommentBy).text());
            self.CommentDate = ko.observable($('<div/>').html(item.CommentDate).text());
        }
        catch (e) {
            var msg = 'Exception' + e + ' | Source: CommentsModel() in ActionPlanDetails.js';
            logger.logMessage(msg);
        }
    }
    function DeleteComment(data) {
        try {
            $("#loadingImgComment").show();
                var csrfToken = $("input[name='__RequestVerificationToken']").val();
                var headers = appsecurity.getSecurityHeaders();
                headers.__RequestVerificationToken = csrfToken;
                return $.ajax({
                    url: "/api/ActionPlan/ActionPlanDeleteComment",
                    type: "POST",
                    headers: headers,
                    data: { ActionPlanId: ActionPlanDetailsVM.ActionPlanId(), CommentId: data.CommentId() }
                })
                    .success(function (jsonResult, error) {
                        if (jsonResult != undefined && jsonResult != -1) {
                            GetActionPlanComments();
                            $('.jqte_editor').html('');
                            $('#TextComment').val('');
                            $("#loadingImgComment").hide();
                            ClearEditComment();
                            logger.logSuccess('Deleted Successfully ', 'Success', system.getModuleId(ActionPlanDetailsVM), true);
                        } else {
                            $('.jqte_editor').html('');
                            $('#TextComment').val('');
                            $("#loadingImgComment").hide();
                            ClearEditComment();
                            logger.logError('Some error occured', 'Error', system.getModuleId(ActionPlanDetailsVM), true);
                        }
                    })
                    .fail(function (jsonResult, error) {
                        $("#loadingImgComment").hide();
                        logger.logError('An error has occurred. Please contact your Administrator.', 'Error', system.getModuleId(ActionPlanDetailsVM), true);
                    });
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: ajaxSuccess in SaveCommentsRichText() method in ActionPlanDetails.js';
            logger.logMessage(msg);
        }
    }

    
    function EditComment(data ){
        try {
            //$("#EditCommentPopUp").modal('show');
            ActionPlanDetailsVM.CommentId(data.CommentId());           
            $('.jqte_editor').html(data.CommentText());
            $('#EditRichTextComments').show();
            $('#RichTextComments').hide();
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: CreateActionPlan() method in ActionPlanDetails.js';
            logger.logMessage(msg);
        }
    }
    
    function SaveEditComment(data) {
        try {
            $("#loadingImgCommentPop").show();
            var csrfToken = $("input[name='__RequestVerificationToken']").val();
            var headers = appsecurity.getSecurityHeaders();
            headers.__RequestVerificationToken = csrfToken;
            return $.ajax({
                url: "/api/ActionPlan/ActionPlanEditComment",
                type: "POST",
                headers: headers,
                data: { ActionPlanId: ActionPlanDetailsVM.ActionPlanId(), CommentId: ActionPlanDetailsVM.CommentId(), CommentText: $("#TextComment").val() }
            })
                .success(function (jsonResult, error) {
                    if (jsonResult != undefined && jsonResult != -1) {
                        GetActionPlanComments();
                        logger.logSuccess('Edited Successfully ', 'Success', system.getModuleId(ActionPlanDetailsVM), true);
                        $("#loadingImgCommentPop").hide();
                        $("#EditCommentPopUp").modal('hide');
                        $('.jqte_editor').html('');
                    } else {
                        logger.logError('Some error occured', 'Error', system.getModuleId(ActionPlanDetailsVM), true);
                        $("#loadingImgCommentPop").hide();
                        $("#EditCommentPopUp").modal('hide');
                        $('.jqte_editor').html('');
                    }
                })
                .fail(function (jsonResult, error) {
                    $("#loadingImgCommentPop").hide();
                    logger.logError('An error has occurred. Please contact your Administrator.', 'Error', system.getModuleId(ActionPlanDetailsVM), true);
                });
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: ajaxSuccess in EditComment() method in ActionPlanDetails.js';
            logger.logMessage(msg);
        }
    }
    
    function GetActionPlanComments() {
        try {
            ActionPlanDetailsVM.ActionPlanCommentsList([]);
            var csrfToken = $("input[name='__RequestVerificationToken']").val();
            var headers = appsecurity.getSecurityHeaders();
            headers.__RequestVerificationToken = csrfToken;
            return $.ajax({
                url: "/api/ActionPlan/GetActionPlanComments",
                type: "GET",
                headers: headers,
                data: { ActionPlanId: ActionPlanDetailsVM.ActionPlanId() }
            })
                .success(function (jsonResult, error) {

                    ActionPlanDetailsVM.ActionPlanCommentsList([]);
                    if (jsonResult != null) {
                        var mappedRole = $.map(jsonResult, function (result) {
                            return new CommentsModel(result);
                        });
                        ActionPlanDetailsVM.ActionPlanCommentsList(mappedRole);
                    }
                    else {
                        ActionPlanDetailsVM.ActionPlanCommentsList([]);
                    }
                })
                .fail(function (jsonResult, error) {
                    logger.logError('An error has occurred while fetching the comments. Please contact your Administrator.', 'Error', system.getModuleId(vm), true);
                });
        }
        catch (e) {
            var msg = 'Exception' + e + ' | Source: GetActionPlanComments() in ActionPlanDetails.js';
            logger.logMessage(msg);
        }
    }

    function HistoryLogAccClick() {
        try {          
            GetHistoryLogEvents();
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: HistoryLogAccClick() method in ActionPlanDetails.js';
            logger.logMessage(msg);
        }
    }

    function GetActionPlanDocs() {
        try {
            ActionPlanDetailsVM.ActionPlanDocList([]);
            var csrfToken = $("input[name='__RequestVerificationToken']").val();
            var headers = appsecurity.getSecurityHeaders();
            headers.__RequestVerificationToken = csrfToken;
            return $.ajax({
                url: "/api/ActionPlan/GetActionPlanDocs",
                type: "GET",
                headers: headers,
                data: { ActionPlanId: ActionPlanDetailsVM.ActionPlanId() }
            })
                .success(function (jsonResult, error) {

                   // ActionPlanDetailsVM.ActionPlanDocList([]);
                    if (jsonResult != null) {
                        var mappedRole = $.map(jsonResult, function (result) {
                            return new DocsModel(result);
                        });
                       // ActionPlanDetailsVM.ActionPlanDocList(mappedRole);

                        ActionPlanDetailsVM.ActionPlanDocList([]);
                        var object = $('#tblActionPlanDocs').DataTable();
                        object.destroy();
                        $('#tblActionPlanDocs tbody tr').remove();
                        ActionPlanDetailsVM.ActionPlanDocList(mappedRole);

                        $("#tblActionPlanDocs").DataTable(
                            {
                                "aoColumnDefs": [{
                                    "aTargets": [0],
                                    "order": [],
                                    "bSortable": false
                                }]
                            }
                            );
                    }
                    else {
                        ActionPlanDetailsVM.ActionPlanDocList([]);
                    }
    
                })
                .fail(function (jsonResult, error) {
                    logger.logError('An error has occurred while fetching the values. Please contact your Administrator.', 'Error', system.getModuleId(vm), true);
                });
        }
        catch (e) {
            var msg = 'Exception' + e + ' | Source: ActionPlanDocList() in ActionPlanDetails.js';
            logger.logMessage(msg);
        }
    }

    
    function DocsModel(item) {
        try {
            var self = this;
            self.FileId = ko.observable(item.FileId);
            self.FileName = ko.observable($('<div/>').html(item.FileName).text());
            self.UploadedBy = ko.observable($('<div/>').html(item.UploadedBy).text());
            self.UploadedOn = ko.observable($('<div/>').html(item.UploadedOn).text());
            self.DocUrl = ko.observable($('<div/>').html(item.DocUrl).text());
            self.Comment = ko.observable($('<div/>').html(item.Comment).text());
        }
        catch (e) {
            var msg = 'Exception' + e + ' | Source: DocsModel() in ActionPlanDetails.js';
            logger.logMessage(msg);
        }
    }
    

    function GetActionItemListForPlan() {
        try {
            ActionPlanDetailsVM.FilteredQuestionsList([]);
            var csrfToken = $("input[name='__RequestVerificationToken']").val();
            var headers = appsecurity.getSecurityHeaders();
            headers.__RequestVerificationToken = csrfToken;
            return $.ajax({
                url: "/api/ActionPlan/GetActionItemListForPlan",
                type: "GET",
                headers: headers,
                data: { ActionPlanId: ActionPlanDetailsVM.ActionPlanId() }
            })
                .success(function (jsonResult, error) {
                    try {
                        if (jsonResult != null) {
                            var mappedRole = $.map(jsonResult, function (result) {
                                return new ActionItemModel(result);
                            });
                            ActionPlanDetailsVM.FilteredQuestionsList([]);
                            var object = $('#tblActionItemList').DataTable();
                            object.destroy();
                            $('#tblActionItemList tbody tr').remove();
                            ActionPlanDetailsVM.FilteredQuestionsList(mappedRole);

                            $("#tblActionItemList").DataTable(
                                {
                                    "aoColumnDefs": [{
                                        "aTargets": [0],
                                        "order": [],
                                        "bSortable": false
                                    }]
                                });
                        }
                        else {
                            ActionPlanDetailsVM.FilteredQuestionsList([]);
                        }

                    }
                    catch (e) {
                        var msg = 'Exception' + e + ' | Source: GetHistoryLogEvents() in ActionPlanDetails.js';
                        logger.logMessage(msg);
                    }
                })
                .fail(function (jsonResult, error) {
                    logger.logError('An error has occurred while fetching the Filter values. Please contact your Administrator.', 'Error', system.getModuleId(vm), true);
                });
        }
        catch (e) {
            var msg = 'Exception' + e + ' | Source: GetHistoryLogEvents() in ActionPlanDetails.js';
            logger.logMessage(msg);
        }
    }

    function ActionItemModel(item) {
        try {
            var self = this;
            self.IS_SELECTED = ko.observable(false);
            self.AIM_TITLE = ko.observable(item.AIM_TITLE);
            self.AIM_GENERIC_ID = ko.observable(item.AIM_GENERIC_ID);
            self.BU_DE_UID = ko.observable(item.BU_DE_UID);
            self.BU_NAME = ko.observable(item.BU_NAME);
            self.ASSESSMENT_PROFILE_APD_UID = ko.observable(item.ASSESSMENT_PROFILE_APD_UID);
            self.ASSESSMENT_PROFILE = ko.observable(item.ASSESSMENT_PROFILE);
            self.ASSESSMENT_TYPE_RAT_UID = ko.observable(item.ASSESSMENT_TYPE_RAT_UID);
            self.RAT_ASSESSMENT_TYPE = ko.observable(item.RAT_ASSESSMENT_TYPE);
            self.CONTROL_AREA_ECA_UID = ko.observable(item.CONTROL_AREA_ECA_UID);
            self.CONTROL_AREA_NAME = ko.observable(item.CONTROL_AREA_NAME);
            self.QUESTION_ECQ_UID = ko.observable(item.QUESTION_ECQ_UID);
            self.QUESTION_TEXT = ko.observable(item.QUESTION_TEXT);
            self.RESPONSE_VALUE = ko.observable(item.RESPONSE_VALUE);
            self.AIM_UID = ko.observable(item.AIM_UID);
            self.APM_UID = ko.observable(item.APM_UID);
            self.ActionPlanList = ko.observable(item.ActionPlanList);
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: ActionItemModel() method in ActionPlanDetails.js';
            logger.logMessage(msg);
        }
    }

    function SelectAllPlanOwners(data, event) {
        try {
            ko.utils.arrayForEach(data.ActionPlanOwnerList(), function (listItem) {
                listItem.IS_SELECTED(event.currentTarget.checked);
            });
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: SelectAllPlanOwners() method in ActionPlanDetails.js';
            logger.logMessage(msg);
        }
    }
    
    function SelectAllPlanReviewers(data, event) {
        try {
            ko.utils.arrayForEach(data.ActionPlanReviewerList(), function (listItem) {
                listItem.IS_SELECTED(event.currentTarget.checked);
            });
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: SelectAllPlanReviewers() method in ActionPlanDetails.js';
            logger.logMessage(msg);
        }
    }

    function UploadAttachmentForPlan() {
        try {
            $("#valDocErrorDoc").hide();

            if ($('#AttachmentComment').val() == "") {
                $('#valDocErrorDoc').show();
                $('#valDocErrorDoc').html('The comment can not be left blank.');
                return false;
            }
            if ($('#AttachmentComment').val().length > 100) {
                $('#valDocErrorDoc').show();
                $('#valDocErrorDoc').html('The comment should not exceed 100 characters.');
                return false;
            }
            var regexp = /^[A-Za-z0-9_&-|//}{\ ~!@#$%^&*()_+]+$/;
            if (!$('#AttachmentComment').val().match(regexp)) {
                $('#valDocErrorDoc').show();
                $('#valDocErrorDoc').html('Invalid input for comment');
                return false;
            }
            if ($('#AttachmentComment').val().indexOf('&') > -1) {
                $('#valDocErrorDoc').show();
                $('#valDocErrorDoc').html('Comment cannot have " & "');
                return false;
            }
            $('#loadingImgMainRD').show();
            var FileList = document.getElementById('FileUploaderForDocuments').files;
            if (FileList.length > 0) {
                var FileName = document.getElementById('FileUploaderForDocuments').files[0].name;
                if (FileName.substring(FileName.lastIndexOf('.') + 1, FileName.length).toUpperCase() == 'PNG'
                    | FileName.substring(FileName.lastIndexOf('.') + 1, FileName.length).toUpperCase() == 'JPG'
                    | FileName.substring(FileName.lastIndexOf('.') + 1, FileName.length).toUpperCase() == 'JPEG'
                    | FileName.substring(FileName.lastIndexOf('.') + 1, FileName.length).toUpperCase() == 'DOCX'
                    | FileName.substring(FileName.lastIndexOf('.') + 1, FileName.length).toUpperCase() == 'DOC'
                    | FileName.substring(FileName.lastIndexOf('.') + 1, FileName.length).toUpperCase() == 'XLS'
                    | FileName.substring(FileName.lastIndexOf('.') + 1, FileName.length).toUpperCase() == 'PDF'
                    | FileName.substring(FileName.lastIndexOf('.') + 1, FileName.length).toUpperCase() == 'CSV'
                    | FileName.substring(FileName.lastIndexOf('.') + 1, FileName.length).toUpperCase() == 'TXT'
                    | FileName.substring(FileName.lastIndexOf('.') + 1, FileName.length).toUpperCase() == 'XLSX'
                    | FileName.substring(FileName.lastIndexOf('.') + 1, FileName.length).toUpperCase() == 'XLSM'
                    | FileName.substring(FileName.lastIndexOf('.') + 1, FileName.length).toUpperCase() == 'BMP'
                    | FileName.substring(FileName.lastIndexOf('.') + 1, FileName.length).toUpperCase() == 'RTF'
                    | FileName.substring(FileName.lastIndexOf('.') + 1, FileName.length).toUpperCase() == 'PPT'
                    | FileName.substring(FileName.lastIndexOf('.') + 1, FileName.length).toUpperCase() == 'PPTX'
                    | FileName.substring(FileName.lastIndexOf('.') + 1, FileName.length).toUpperCase() == 'MSG') {

                    if (FileList[0].size <= 20145728) {
                        $("#valDocErrorDoc").hide();
                               // $('#lblProgressMsg').removeClass('field-validation-error');
                                var FormDataObj = new FormData();
                                FormDataObj.append("File1", FileList[0]);
                                var request = new XMLHttpRequest();
                               // $('#ProgressBarMainDiv').show();
                        ActionPlanDetailsVM.AttachmentComment($('#AttachmentCommentItem').val());

                                request.onreadystatechange = function () {
                                    if (request.readyState == 1) {
                                        //ActionPlanDetailsVM.ProgressMessage("Initializing File Upload...");
                                    }
                                    else if (request.readyState == 4) {
                                        if (request.status == 200) {
                                            if (request.responseText != null && request.responseText != "" && request.responseText != "null") {
                                                //ActionPlanDetailsVM.ProgressMessage("The file has been uploaded successfully.");
                                                //var DocName = document.getElementById('FileUploaderForDocuments').files[0].name;
                                                document.getElementById('FileUploaderForDocuments').value = null;
                                                $('#loadingImgMainRD').hide();
                                                logger.logSuccess('File Uploaded Successfully', 'Success', system.getModuleId(ActionPlanDetailsVM), true);
                                                GetActionPlanDocs();
                                                $('#AttachmentComment').val("");
                                            }
                                            else {
                                                document.getElementById('FileUploaderForDocuments').value = null;
                                                logger.logError('Some error occured', 'Error', system.getModuleId(ActionPlanDetailsVM), true);
                                                $('#loadingImgMainRD').hide();
                                            }
                                        }
                                        else
                                            ajaxFail(request, "");
                                    }
                                };
                                request.upload.addEventListener('progress', function (event) {
                                    //SrViewModel.ProgressPercent(parseInt((event.loaded / event.total) * 100) + '%');
                                   // ActionPlanDetailsVM.ProgressMessage("Uploading File...");
                                });
                                
                                request.withCredentials = true;
                                var csrfToken = $("input[name='__RequestVerificationToken']").val();
                                var headers = appsecurity.getSecurityHeaders();
                                headers.__RequestVerificationToken = csrfToken;
                        request.open('POST', '/api/ActionPlan/UploadActionPlanDoc?ActionPlanId=' + ActionPlanDetailsVM.ActionPlanId() + '&Comment=' + ActionPlanDetailsVM.AttachmentComment());
                                request.setRequestHeader('Authorization', headers.Authorization);
                                request.setRequestHeader('RT', headers.RT);
                                request.setRequestHeader('__RequestVerificationToken', headers.__RequestVerificationToken);
                                request.send(FormDataObj);
                        }
                    else
                    {
                        $('#loadingImgMainRD').hide();
                        $('#valDocErrorDoc').show();
                        $('#valDocErrorDoc').html('Upload file size cannot exceed' + (ActionPlanDetailsVM.UploadFileSize() / 1048576) + " MB. Please try uploading a file of lesser size.");
                    }
                }
                else {
                    $('#loadingImgMainRD').hide();
                    $('#valDocErrorDoc').show();
                    $('#valDocErrorDoc').html('Please select a valid file to upload.');
                }
            }
            else
            {
                $('#loadingImgMainRD').hide();
                $('#valDocErrorDoc').show();
                $('#valDocErrorDoc').html('Please select a file to upload.');
            }

            function ajaxFail(error, status) {
                logger.logError('An error has occurred while fetching the Filter values. Please contact your Administrator.', 'Error', system.getModuleId(ActionPlanDetailsVM), true);
            };
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: ajaxSuccess in UploadAttachmentForPlan() method in ActionPlanDetails.js';
            logger.logMessage(msg);
        }
    }


    function ActionPlanPriorityChange(data, event) {
        try {
            var selectedText = document.getElementById('ddlActionPlanPriority').options[document.getElementById('ddlActionPlanPriority').selectedIndex].innerText;
            if (selectedText != undefined && selectedText != "-Select-") {
                        $("#PlanPriorityText").val(selectedText);
            }
        }
        catch (e) {
            var msg = 'Exception' + e + ' | Source | ActionPlanPriorityChange() in ActionPlanDetails.js';
            logger.logMessage(msg);
        }
    }
    
    function AttachmentAccordian() {
        try {
            GetActionPlanDocs();
        }
        catch (e) {
            var msg = 'Exception' + e + ' | Source | AttachmentAccordian() in ActionPlanDetails.js';
            logger.logMessage(msg);
        }
    }

         function DeleteAttachment(data, event) {
             try {
                 $("#loadingImgMainRD").show();
                 
                 var csrfToken = $("input[name='__RequestVerificationToken']").val();
                 var headers = appsecurity.getSecurityHeaders();
                 headers.__RequestVerificationToken = csrfToken;
                 return $.ajax({
                     url: "/api/ActionPlan/DeletePlanAttachment",
                     type: "POST",
                     headers: headers,
                     data: { ActionPlanId: ActionPlanDetailsVM.ActionPlanId(), DocumentName: data.FileName(), DocuSubLocation: data.DocUrl(), DocumentId: data.FileId(), DocumentLocation: data.DocUrl() + data.FileId() + ActionPlanDetailsVM.ActionPlanId() + '.' + data.FileName().split('.').pop() }
                 })
                     .success(function (jsonResult, error) {
                         if (jsonResult != undefined && jsonResult == "NotFound") {
                             $("#loadingImgMainRD").hide();
                             logger.logError('Some error occured, Please contact the Administrator', 'Error', system.getModuleId(ActionPlanDetailsVM), true);
                         }
                         else if (jsonResult != undefined && jsonResult != "-1") {
                             $("#loadingImgMainRD").hide();
                             logger.logSuccess('File Deleted Successfully ', 'Success', system.getModuleId(ActionPlanDetailsVM), true);
                             GetActionPlanDocs();
                         } else {
                             $("#loadingImgMainRD").hide();
                             logger.logError('Some error occured, Please contact the Administrator', 'Error', system.getModuleId(ActionPlanDetailsVM), true);
                         }

                     })
                     .fail(function (jsonResult, error) {
                         $("#loadingImgMainRD").hide();
                         logger.logError('An error has occurred while fetching the Filter values. Please contact your Administrator.', 'Error', system.getModuleId(vm), true);
                     });
             }
             catch (e) {
                 var msg = 'Exception' + e + ' | Source | DeleteAttachment() in ActionPlanDetails.js';
                 logger.logMessage(msg);
             }
         }

         function DownloadAttachment(data, event) {
             try {
                 var payLoad = {
                     t: appsecurity.getAuthenticationInfo(), FilePath: data.DocUrl(), FileName: data.FileName(), FileId: data.FileId().toString() + ActionPlanDetailsVM.ActionPlanId().toString()
                 };
                 utils.postAndRedirect(rootPath + "/FileDownload/DownloadActionPlanDocument", payLoad, '_blank');
             }
             catch (e) {
                 var msg = 'Exception' + e + ' | Source | DownloadAttachment() in ActionPlanDetails.js';
                 logger.logMessage(msg);
             }
         }


        function ViewActionItemDetails(data) {
            try {
                ActionPlanDetailsVM.appsecurity.ActionFlagType("Plan");
                ActionPlanDetailsVM.ResponseMoveArrayItem(new ResponseMoveModel1({ ActionPlanId: ActionPlanDetailsVM.ActionPlanId(), ActionItemId: data.AIM_UID(), ActionItemNumber: data.AIM_GENERIC_ID(), RoleName: '', ActionItemStatus: '', RoleId: '', CompletedFlag: true, IsComposeFlag: ko.observable(1) }));
                router.navigate("#ActionTracker/ActionItemDetails", true);
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ViewActionItemDetails() method in ActionPlanDetails.js';
                logger.logMessage(msg);
            }
        }

        function ResponseMoveModel1(item) {
            try {
                var self = this;
                self.ActionPlanId = ko.observable(item.ActionPlanId);
                self.ActionItemId = ko.observable(item.ActionItemId);
                self.ActionItemNumber = ko.observable(item.ActionItemNumber);
                self.RoleName = ko.observable(item.RoleName);
                self.RoleId = ko.observable(item.RoleId);
                self.ActionItemStatus = ko.observable(item.ActionItemStatus);
                self.CompletedFlag = ko.observable(item.CompletedFlag);
                self.IsComposeFlag = ko.observable(1);
            }
            catch (e) {
                var msg = 'Exception' + e + ' | Source: ResponseMoveModel() in ActionPlanDetails.js';
                logger.logMessage(msg);
            }
        }

        
        function CreateActionItemFromPlan(data) {
            try {
                ActionPlanDetailsVM.ResponseMoveArrayItem(new ResponseMoveModel1({ ActionPlanId: ActionPlanDetailsVM.ActionPlanId(), ActionItemId: '', ActionItemNumber: ActionPlanDetailsVM.ActionPlanLabel(), RoleName: '', ActionItemStatus: '', RoleId: '', CompletedFlag: 1, IsComposeFlag: ko.observable(1) }));
                router.navigate("#ActionTracker/ConfigureActionTracker", true);
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: CreateActionItemFromPlan() method in ActionPlanDetails.js';
                logger.logMessage(msg);
            }
        }
    
});
